import { createSlice } from '@reduxjs/toolkit'
import MOLDOVA_CITIES from './cities'

// Resolve the index that was last selected by the user (if any).
// Clamp to the available city list so an old, out-of-range value can't break the UI.
const storedIndex = Number(localStorage.getItem('locationIndex'))
const initialIndex = Number.isFinite(storedIndex) && storedIndex >= 0 && storedIndex < MOLDOVA_CITIES.length ? storedIndex : 0

const initialState = {
  loading: false,
  locationsData: MOLDOVA_CITIES,
  locationIndex: initialIndex,
  error: null,
  success: true,
}

const locationsSlice = createSlice({
  name: 'locations',
  initialState,
  reducers: {
    setLocation: (state, action) => {
      localStorage.setItem('locationIndex', action.payload)
      state.locationIndex = Number(action.payload)
    },
  },
})

export const { setLocation } = locationsSlice.actions

export default locationsSlice.reducer
